// https://nodejs.org/api/packages.html#packages_writing_dual_packages_while_avoiding_or_minimizing_hazards
import HighlightJS from '../lib/core.js';
export { HighlightJS };
export default HighlightJS;
